import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { LoaderService } from '../../shared/services/loader.service';
import { ApiService } from '../../shared/services/api.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-most-searched-models-component',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './most-searched-models-component.component.html',
  styleUrl: './most-searched-models-component.component.scss',
})
export class MostSearchedModelsComponentComponent {
  currentSlide = 0;
  totalSlides = 4;
  visibleSlides = 3; // Default for desktop
  slideWidth = 310;
  gap = 24;
  isBrowser: boolean;

  vehicles: any;
  private dataLoaded = false;

  sub: Subscription = new Subscription();
  isDesktop: boolean = false;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private apiService: ApiService,
    private loaderService: LoaderService,
    private router: Router,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (this.dataLoaded) return;
    this.dataLoaded = true;

    this.getMostSearchModel();
    //this.totalSlides = this.vehicles?.length;
    if (this.isBrowser) {
      this.updateVisibleSlides();
    }
  }

  @HostListener('window:resize')
  onResize(): void {
    if (this.isBrowser) {
      this.updateVisibleSlides();
    }
  }

  updateVisibleSlides(): void {
    if (!this.isBrowser) return;

    const windowWidth = window.innerWidth;
    if (windowWidth < 640) {
      this.visibleSlides = 2; // sm
      this.slideWidth = 198;
      this.gap = 12;
      this.isDesktop = false;
    } else if (windowWidth < 768) {
      this.visibleSlides = 4; // md
      this.slideWidth = 224;
      this.gap = 16;
      this.isDesktop = false;
    } else {
      this.visibleSlides = 3; // lg/desktop
      this.slideWidth = 310;
      this.gap = 24;
      this.isDesktop = true;
    }
  }

  next(): void {
    if (this.currentSlide < this.totalSlides - this.visibleSlides) {
      this.currentSlide++;
    }
  }

  prev(): void {
    if (this.currentSlide > 0) {
      this.currentSlide--;
    }
  }

  getMostSearchModel() {
    const payload = {};
    this.loaderService.show();

    this.sub.add(
      this.apiService.getModelSearch(payload).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.vehicles = res?.data;
            this.totalSlides = this.vehicles?.length;
          }
          this.loaderService.hide();
        },
        error: (err: any) => {
          console.error('Failed to fetch blog list', err);
          this.loaderService.hide();
        },
      }),
    );
  }

  gotoproductList(data: any): void {
    // localStorage.setItem('categoryType', JSON.stringify('spareParts'));
    // Do something with confirmation
    localStorage.removeItem('mostSearchedModel');
    localStorage.removeItem('category');
    localStorage.removeItem('filterState');
    localStorage.removeItem('guideSearchData');
    localStorage.removeItem('MyGarageData');
    localStorage.removeItem('SpareCategory');
    localStorage.removeItem('categoryType');
    localStorage.removeItem('product_categoryType');
    localStorage.removeItem('product_category');

    localStorage.setItem('mostSearchedModel', JSON.stringify(data));

    this.router.navigate(['/product-list']);
  }

  seeMoregotoProductList(section: string) {
    // Handle see more navigation
    localStorage.removeItem('filterState');
    localStorage.removeItem('category');
    localStorage.removeItem('guideSearchData');
    localStorage.removeItem('categoryType');
    localStorage.removeItem('seemore');
    localStorage.removeItem('MyGarageData');
    localStorage.removeItem('SpareCategory');
    localStorage.removeItem('mostSearchedModel');

    const searchData = section;

    localStorage.setItem('seemore', searchData);

    // Check if we're already on the product-list page
    // if (this.router.url === '/product-list' || this.router.url.startsWith('/product-list')) {
    //   // Use behavior subject to notify product-list component
    //   this.behaviourSubject.setCategoryChanged({ section: section, isSeeMore: true });
    // } else {
    this.router.navigate(['/product-list']);
    // }
    // this.showSearchPopup = false;
    // this.advanceSearchData = null;
    // this.selectedChip = null;
    // this.selectedSearchFields = {
    //   make: '',
    //   model: '',
    //   year_of_manufacture: '',
    //   variant: '',
    // };
    // this.cdref.detectChanges();
  }
}

interface VehicleModel {
  id: number;
  imageUrl: string;
  title: string;
  partsAvailable: number;
  gradeAPercentage: number;
}
